<template>
  <div class="planned-allocation" data-testid="planned-allocation">
    <div v-if="hasError" class="planned-allocation__error">
      <BaseText>
        Não foi possível carregar os dados neste momento. Aguarde alguns
        instantes e tente novamente.
      </BaseText>
      <ButtonTertiary
        label="Tentar novamente"
        @click="fetchPlannedAllocation"
      />
    </div>
    <AllocationLoader v-else-if="isLoading" />
    <section v-else-if="plannedAllocation">
      <PlannedChart
        class="planned-allocation__chart"
        :planned-chart="plannedChart"
      />
      <PlannedTable
        :portfolio-id="portfolioId"
        :planned-table="plannedTable"
        :has-applied="hasApplied"
      />
    </section>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';

import { BaseText, ButtonTertiary } from '@warrenbrasil/nebraska-web';
import { PlannedChart, PlannedTable } from './components';
import { AllocationLoader } from '@/modules/wealth/components/AllocationLoader';

import {
  getPlannedAllocation,
  IPlannedAllocation
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  portfolioId: string;
  hasApplied: boolean;
  isCustom: boolean;
}

const props = defineProps<Props>();

const plannedAllocation = ref<IPlannedAllocation>();
const isLoading = ref(true);
const hasError = ref(false);

const plannedChart = computed(() => {
  return plannedAllocation.value!.chart;
});

const plannedTable = computed(() => {
  return plannedAllocation.value!.items;
});

async function fetchPlannedAllocation() {
  hasError.value = false;
  isLoading.value = true;

  try {
    const params = {
      hasApplied: props.hasApplied
    };
    plannedAllocation.value = await getPlannedAllocation(
      props.portfolioId,
      params
    );
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  !props.isCustom && fetchPlannedAllocation();
});
</script>

<style lang="less" scoped>
.planned-allocation {
  &__error {
    width: 320px;
    height: 360px;
    margin: auto;
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__chart {
    margin-bottom: @size-spacing-x500;
  }
}
</style>
